"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Focus = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var theme_1 = require("../../../theme");
function Focus(_a) {
    var _b = _a.jagexLauncherTitleText, jagexLauncherTitleText = _b === void 0 ? "Jagex Launcher" : _b, _c = _a.jagexLauncherAltText, jagexLauncherAltText = _c === void 0 ? "Jagex Launcher" : _c, children = _a.children;
    var nullBreaks = [null, null, null, null];
    return (theme_ui_1.jsx(theme_ui_1.Grid, { sx: {
            background: theme_1.theme.colors.secondary,
            height: "100vh",
            position: "relative",
            width: "100%",
            zIndex: 1,
        }, variant: "primary" },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                gridColumnStart: 5,
                gridColumnEnd: 9,
                gridRowStart: 2,
                gridRowEnd: 3,
                justifyContent: "center",
            } },
            theme_ui_1.jsx(__1.LauncherLogo, { title: jagexLauncherTitleText, alt: jagexLauncherAltText })),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                flexDirection: "column",
                gridColumnStart: __spreadArrays([5], nullBreaks, [6]),
                gridColumnEnd: __spreadArrays([9], nullBreaks, [8]),
                gridRowStart: 4,
                gridRowEnd: 10,
                justifyContent: "center",
                textAlign: "center",
            } }, children)));
}
exports.Focus = Focus;
